define('observable',['underscore'], function(_){

  return {
    inform: function (what) {
      var args = Array.prototype.slice.call(arguments, 1);
      var list = Array.prototype.slice.call(this.getSubscribers(what));
      for (var i = 0; i < list.length; i++) {
        if (list[i] === null) continue;
        try {
          list[i].apply(this, args);
        } catch(e) {
          // we want the loop to continue, but we don't want to swallow the
          setTimeout(function() { throw e; }, 0);
        }
      }
      return this;
    },

    getSubscribers: function(toWhat) {
      return this.__observableEvents[toWhat] ||
      (this.__observableEvents[toWhat] = []);
    },

    clearSubscribers: function(toWhat) {
      if (toWhat) {
        this.__observableEvents[toWhat] = [];
      }
      return this;
    },

    clearAllSubscribers: function() {
      this.__observableEvents = {};
      return this;
    },

    subscribe: function(toWhat, withWhat) {
      var list = this.getSubscribers(toWhat);
      list.push(withWhat);
      return this;
    },

    unsubscribe: function(toWhat, withWhat) {
      var list = this.getSubscribers(toWhat);
      for (var i = 0; i < list.length; i++) {
        if (list[i] === withWhat) {
          list.splice(i, 1);
          break;
        }
      }
      return this;
    },

    monitor: function(toWhat, withWhat) {
      if (!withWhat()) {
        var monitor = _.bind(function(value) {
          if (withWhat.apply(withWhat, arguments)) {
            this.unsubscribe(toWhat, monitor);
          }
        }, this);
        this.subscribe(toWhat, monitor);
      }
      return this;
    }
  };
});

